import React from "react";
import { Route, BrowserRouter as Router, Switch } from "react-router-dom";
import NotFoundPage from "./components/404";
import Forgot from "./pages/auth/Forgot";
import Login from "./pages/auth/Login";
import Register from "./pages/auth/Register";
import Employee from "./pages/dashboard/employee/employee";
import ExecutiveReport from "./pages/dashboard/ExecutiveReport";
import Forms from "./pages/dashboard/Forms";
import NewExecutiveReport from "./pages/dashboard/NewExecutiveReport";
import NewExecutiveReport2025 from "./pages/dashboard/NewExecutiveReport_2025-04";
import Report from "./pages/dashboard/Report";
import ProtectedRoute from "./utilities/ProtectedRoute";

const App = () => {
  return (
    <Router>
      <Switch>
        <ProtectedRoute exact path="/" component={Forms} />
        <ProtectedRoute exact path="/team" component={Employee} />
        <ProtectedRoute exact path="/report" component={Report} />
        <ProtectedRoute exact path="/ereport" component={ExecutiveReport} />
        <ProtectedRoute
          exact
          path="/newereport"
          component={NewExecutiveReport}
        />
        <ProtectedRoute
          exact
          path="/newereport2025apr"
          component={NewExecutiveReport2025}
        />
        <Route exact path="/auth" component={Login} />
        <Route exact path="/clinic/clinic-register" component={Register} />
        <Route exact path="/forgot-password" component={Forgot} />
        <Route exact path="*" component={NotFoundPage} />
      </Switch>
    </Router>
  );
};

export default App;
